import { spawn } from 'redux-saga/effects';

import backup from './backup/backupSagas';

export default function* sagas() {
	yield spawn(backup);
}
